export default __webpack_public_path__ + "static/calltoactions-96545fd1c9d1696764ec26c68fea733f.png";